import React, {createRef} from "react";
import Selecto from "react-selecto";
import shortid from "shortid";
import BaseComponent from "../BaseComponent";
import PropTypes from "prop-types";
import {List, ListItem} from "@mui/material";
import {
  FilterTiltShift,
  KeyboardArrowUp,
  KeyboardCommandKey,
  KeyboardControlKey,
  TipsAndUpdates
} from "@mui/icons-material";
import AccordionLayout from "../accordion/AccordionLayout";
import AccordionItemHead from "../accordion/AccordionItemHead";
import AccordionItem from "../accordion/AccordionItem";

class SelectableDragList extends BaseComponent {

  containerId = 'selectoContainer_' + shortid();
  data = new Set();
  selectoRef = createRef();

  handleSelect = (e) => {
    e.added.forEach((el) => {
      this.data.add(el.getAttribute('data-element-id')); // Add key to the set
      el.classList.add('selected');
    });

    e.removed.forEach((el) => {
      this.data.delete(el.getAttribute('data-element-id')); // Remove key from the set
      el.classList.remove('selected');
    });
    this.onChange();
  };

  onChange() {
    if (this.props.onChange) {
      this.props.onChange(this.getData());
    }
  }

  getData() {
    return Array.from(this.data);
  }

  setSelectedTargets(selectedTargets) {
    this.selectoRef.current.setSelectedTargets(selectedTargets);
  }

  /**
   * This method needs to be called in the componentDidMount method of the component that wants to render this
   * Because the framework does not provide another way to add default selected elements
   */
  setDefaultSelectedTargets() {
    let targets = document.getElementById(this.containerId).getElementsByClassName('selectoItem');
    let targetsArray = Array.from(targets).map((element) => {
      if (element.getAttribute('data-element-active') === 'true') {
        element.classList.add('selected');
        this.data.add(element.getAttribute('data-element-id'));
      }
      return element;
    });
    this.selectoRef.current.setSelectedTargets(targetsArray);
  }

  render() {
    return (<>

      {!this.props.hideTips && <AccordionLayout>
        <AccordionItemHead>
          <TipsAndUpdates color='secondary' className='mr-2'/> Tipps
        </AccordionItemHead>
        <AccordionItem>
          <List>
            <ListItem>
              Mit dem Zeiger über die Schaltflächen ziehen um mehrere Felder zu selektieren
            </ListItem>
            <ListItem>
              ⇧ gedrückt halten und einzelne Felder anklicken um anzuwählen
            </ListItem>
            <ListItem>
              ⇧ + <KeyboardControlKey/>/<KeyboardCommandKey/> -Taste gedrückt halten und ausgewählte Felder
              anklicken
              um abzuwählen
            </ListItem>
          </List>
        </AccordionItem>
      </AccordionLayout>}

      <Selecto ref={this.selectoRef}
               dragContainer={'#' + this.containerId + '.elementsContainer'}
               selectableTargets={['#' + this.containerId + ' .selectoItem']}
               onSelect={this.handleSelect}
               hitRate={0}
               selectByClick={true}
               selectFromInside={true}
               continueSelect={false}
               continueSelectWithoutDeselect={true}
               toggleContinueSelect='shift'
               toggleContinueSelectWithoutDeselect={[['ctrl'], ['meta']]}
               ratio={0}/>
      <div className='elementsContainer selecto-area flex flex-wrap gap-1' id={this.containerId}>
        {this.props.children}
      </div>
    </>);
  }
}

SelectableDragList.propTypes = {
  onChange: PropTypes.func, hideTips: PropTypes.bool,
}

export default SelectableDragList;
